import graphql from 'babel-plugin-relay/macro'

export default graphql`
  query CountBulletinsQuery(
    $filters: [Filter]
    $companyId: ID!
    $propertyUnitId: ID!
  ) {
    Me {
      id
      Company(id: $companyId) {
        HouseEntrance(id: $propertyUnitId) {
          data: countBulletins(options: { filters: $filters })
        }
      }
    }
  }
`
